export const GET_CONTACT_API_ENDPOINT = '/booking-portal/ContactV2/GetContact';
